import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  showModal = false;

  toggleSupportModal(): void {
    this.showModal = !this.showModal;
  }

  // Close modal when clicking outside
  @HostListener('document:click', ['$event'])
  closeModalOnClickOutside(event: MouseEvent): void {
    if (!this.showModal) return;
    
    const modalContent = document.querySelector('.modal-content');
    const supportButton = document.querySelector('.support-button');
    
    if (modalContent && !modalContent.contains(event.target as Node) && 
        supportButton && !supportButton.contains(event.target as Node)) {
      this.showModal = false;
    }
  }

  downloadPdf() {
    const pdfUrl = './assets/KYA.pdf';
    const pdfName = 'KYA.pdf';
    
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfName;
    link.target = '_blank';
    
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
  }

  downloadPdf2() {
    const pdfUrl = './assets/QA.pdf';
    const pdfName = 'QA.pdf';
    
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = pdfName;
    link.target = '_blank';
    
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      document.body.removeChild(link);
    }, 100);
  }

  downloadPrivacyPdf() {
    // Path to your privacy policy PDF file
    const link = document.createElement('a');
    link.href = 'assets/privacy.pdf';
    link.download = 'privacy.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}